import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer, EuiButton } from '@elastic/eui';
import NavButtons from 'components/Indoor_Cameras/IN-3011/NavButtons';
import TableFeatures from 'components/Indoor_Cameras/IN-3011/TableFeatures';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  EuiButton,
  NavButtons,
  TableFeatures,
  BreadCrumbs,
  SEOHelmet,
  React
};